import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { config } from '../../config';
import { fetchUser } from '../../redux/Slices/thunks';
import Spinner from '../Global/Spinner';
import './index.scss';

const Verify = () => {
    const [status, setStatus] = useState('Verifying your email...');
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const token = new URLSearchParams(location.search).get('token');

    useEffect(() => {
        if (!token) {
            setStatus('Invalid verification link. No token provided.');
            return;
        }

        const verifyEmail = async () => {
            try {
                const response = await fetch(`${config.API_URI}/v1/users/verify`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ token }),
                });

                const data = await response.json();

                if (response.ok && data.verified) {
                    setIsSuccess(true);
                    setStatus(data.message || 'Email verified successfully! Welcome to Zoobbe!');

                    // Update Redux store with user data
                    dispatch(fetchUser());

                    // Redirect to user's boards after a short delay
                    setTimeout(() => {
                        if (data.user && data.user.username) {
                            window.location.href = `/u/${data.user.username}/boards`;
                        } else {
                            // Fallback: redirect to home and let the app handle routing
                            window.location.href = '/';
                        }
                    }, 2000);
                } else {
                    setIsSuccess(false);
                    if (data.alreadyUsed) {
                        setStatus('This verification link has already been used. Please log in to your account.');
                        setTimeout(() => {
                            navigate('/login');
                        }, 3000);
                    } else {
                        setStatus(data.message || 'Verification failed. The link may be invalid or expired.');
                        setTimeout(() => {
                            navigate('/login');
                        }, 3000);
                    }
                }
            } catch (error) {
                console.error('Verification error:', error);
                setIsSuccess(false);
                setStatus('An error occurred during verification. Please try again.');
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            }
        };

        verifyEmail();
    }, [token, navigate, dispatch]);

    return (
        <div className="verify-container">
            <div className="verifying-content">
                {!isSuccess && (
                    <div className="verifying-spinner">
                        <Spinner size={24} color="var(--brand-color)" speed={2.5} strokeWidth={6} />
                    </div>
                )}

                <div className={`verification-status ${isSuccess ? 'success' : ''}`}>
                    {status}
                </div>

                {isSuccess && (
                    <div className="verification-success-banner">
                        🎉 Your account is now verified! Redirecting to your workspace...
                    </div>
                )}
            </div>
        </div>
    );
};

export default Verify;
